import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { Alert } from "@devowl-wp/react-folder-tree";
import { useStores } from "../../store/rootStore.js";
import { __ } from "../../utils/i18n.js";
import { request } from "../../utils/request.js";
import { locationRestNoticeLiteDelete } from "../../wp-api/noticeLite.delete.js";
async function dismiss() {
    await request({
        location: locationRestNoticeLiteDelete
    });
    window.location.reload();
}
const ProFooter = observer(({ closeable = false })=>{
    const { optionStore: { others: { proUrl } } } = useStores();
    return /*#__PURE__*/ _jsx(Alert, {
        message: /*#__PURE__*/ _jsxs("span", {
            children: [
                __("Thanks for using Real Category Management (Free)."),
                " ",
                /*#__PURE__*/ _jsx("a", {
                    href: `${proUrl}&feature=sidebar`,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: __("Learn more about PRO")
                }),
                closeable && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        " ",
                        "\xb7",
                        " ",
                        /*#__PURE__*/ _jsx("a", {
                            onClick: dismiss,
                            href: "#",
                            children: __("Hide for 30 days")
                        })
                    ]
                })
            ]
        }),
        type: "info",
        style: {
            marginBottom: "10px"
        }
    });
});
export { ProFooter };
